import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "_pa-3" }
const _hoisted_2 = {
  key: 1,
  class: "_ba-1 _rounded--input _bc--input _pa-2 _tac",
  "data-qa": "mini-wizard-item:Empty"
}
const _hoisted_3 = {
  class: "_flexwrap _jc-sb _ai-c",
  "data-qa": "mini-wizard:YourPledge"
}
const _hoisted_4 = {
  class: "_flexwrap _jc-sb _ai-c",
  "data-qa": "mini-wizard:YourPledge"
}
const _hoisted_5 = {
  key: 0,
  class: "gfu-project-mini-wizard__caption _flex-basis-100"
}
const _hoisted_6 = {
  key: 0,
  class: "_flexwrap _jc-sb _ai-c"
}
const _hoisted_7 = {
  class: "gfu-project-mini-wizard__price _tc--accent",
  "data-qa": "mini-wizard:UsedCreditsAmount"
}
const _hoisted_8 = {
  key: 3,
  class: "_tac"
}
const _hoisted_9 = {
  key: 4,
  class: "_tac"
}
const _hoisted_10 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mini_wizard_sticky_backer = _resolveComponent("mini-wizard-sticky-backer")
  const _component_mini_wizard_sticky_amount = _resolveComponent("mini-wizard-sticky-amount")
  const _component_mini_wizard_sticky_credits = _resolveComponent("mini-wizard-sticky-credits")
  const _component_mini_wizard_sticky_header = _resolveComponent("mini-wizard-sticky-header")
  const _component_mini_wizard_items_content = _resolveComponent("mini-wizard-items-content")
  const _component_base_heading = _resolveComponent("base-heading")
  const _component_mini_wizard_sticky_price = _resolveComponent("mini-wizard-sticky-price")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_router_link = _resolveComponent("router-link")
  const _component_mini_wizard_sticky_submit = _resolveComponent("mini-wizard-sticky-submit")
  const _component_mini_wizard_sticky_footer = _resolveComponent("mini-wizard-sticky-footer")
  const _component_mini_wizard_sticky = _resolveComponent("mini-wizard-sticky")

  return (_ctx.rewardsSection)
    ? (_openBlock(), _createBlock(_component_mini_wizard_sticky, {
        key: 0,
        "is-processing": _ctx.isProcessing,
        "data-qa": "project-mini-wizard"
      }, {
        header: _withCtx(() => [
          _createVNode(_component_mini_wizard_sticky_header, {
            "has-logo": true,
            "data-qa": "mini-wizard-header"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_mini_wizard_sticky_backer),
              _createVNode(_component_mini_wizard_sticky_amount),
              _createVNode(_component_mini_wizard_sticky_credits)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!_ctx.allItemsRemoved)
              ? (_openBlock(), _createBlock(_component_mini_wizard_items_content, {
                  key: 0,
                  rewards: _ctx.rewards,
                  addons: _ctx.addons,
                  "is-unmodified-pledge": _ctx.isUnmodifiedPledge,
                  "can-delete-items": _ctx.canDeleteItems,
                  "show-addons": !_ctx.isPledgeEmpty,
                  "pledge-date": _ctx.pledgeDate,
                  "show-delete-button": false,
                  "show-rewards-header": false,
                  "delete-method": _ctx.onDeleteItem
                }, null, 8 /* PROPS */, ["rewards", "addons", "is-unmodified-pledge", "can-delete-items", "show-addons", "pledge-date", "delete-method"]))
              : _createCommentVNode("v-if", true),
            (_ctx.allItemsRemoved)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardRemovedAllItemsText), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        footer: _withCtx(() => [
          (!_ctx.isPledgeEmpty || _ctx.allItemsRemoved)
            ? (_openBlock(), _createBlock(_component_mini_wizard_sticky_footer, {
                key: 0,
                class: "_flexcol _gap-2"
              }, {
                default: _withCtx(() => [
                  (!_ctx.hasSameItemsAsParent)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_base_heading, {
                            tag: "h6",
                            variant: "light"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.MiniWizardModifyingPledgeCostBeforeLabel), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_mini_wizard_sticky_price, {
                            price: _ctx.pledge.parentOrder.totalDiscountedValueConverted
                          }, null, 8 /* PROPS */, ["price"])
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_base_heading, {
                            tag: "h6",
                            variant: "light"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.MiniWizardModifyingPledgeCostAfterLabel) + " ", 1 /* TEXT */),
                              _createVNode(_component_tooltip, { text: "Does not include shipping." }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_base_icon, { name: "circle-info" })
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_mini_wizard_sticky_price, {
                            price: _ctx.pledge.totalDiscountedValueConverted
                          }, null, 8 /* PROPS */, ["price"]),
                          (_ctx.hasTaxHandlingEnabled)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.taxesSummaryLabel), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ]),
                        (_ctx.isProjectInFundingPhase && _ctx.pledge.creditDiscountConverted)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createVNode(_component_base_heading, {
                                tag: "h6",
                                variant: "light"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.MiniWizardCreditDiscountLabel), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createElementVNode("div", _hoisted_7, _toDisplayString($options.usedCreditsAmount), 1 /* TEXT */)
                            ]))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  (_ctx.rewardsSection?.urlName && _ctx.canAddNewItems)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        class: "gfu-btn gfu-btn--soft gfu-btn--block gfu-btn--narrow gfu-btn--primary",
                        to: {name: 'page-section', params: { section: _ctx.rewardsSection.urlName }},
                        "data-qa": "mini-wizard-button:AddMoreItems"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_base_icon, {
                            name: "plus",
                            class: "_fl"
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardUpgradePledgeButton), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["to"]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.addonsSection?.urlName && _ctx.canAddNewItems)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 2,
                        class: "gfu-btn gfu-btn--soft gfu-btn--block gfu-btn--narrow gfu-btn--primary",
                        to: { name: 'page-section', params: { section: _ctx.addonsSection.urlName } },
                        "data-qa": "mini-wizard-button:PickAddons"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_base_icon, {
                            name: "plus",
                            class: "_fl"
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardMoreAddOnsButton), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["to"]))
                    : _createCommentVNode("v-if", true),
                  _createVNode(_component_mini_wizard_sticky_submit, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.MiniWizardCompletePledgeButton), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  (_ctx.isUnfinishedOrder && _ctx.isEditingPledge && !_ctx.hasSameItemsAsParent)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("button", {
                          class: "gfu-link gfu-link--accent",
                          onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => (_ctx.onRevertChanges && _ctx.onRevertChanges(...args)), ["prevent"])),
                          "data-qa": "mini-wizard-button:RevertChanges"
                        }, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardRevertChangesButton), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  ((_ctx.isPledgePlaced && !_ctx.hasSameItemsAsParent) || !_ctx.isPledgeEmpty)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("a", {
                          class: "gfu-link gfu-link--accent",
                          href: _ctx.currentPledge.cartDetailsUrl,
                          "data-qa": "mini-wizard-button:ManageYourPledge"
                        }, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardManagePledgeButton), 9 /* TEXT, PROPS */, _hoisted_10)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["is-processing"]))
    : _createCommentVNode("v-if", true)
}